import { useMemo } from 'react';
import type { User } from '../schemas/user';
import type { Transaction } from '../schemas/transaction';
import { groupBy } from '../utils/risk';

/**
 * Groups transactions by planet ID using users' homeworld as the mapping key.
 * Shared by usePlanetRisks (dashboard) and useHighRiskPlanets (alerts).
 */
export function useTxByPlanet(
  users: User[] | undefined,
  transactions: Transaction[] | undefined
): Map<string, Transaction[]> {
  return useMemo(() => {
    if (!users || !transactions) return new Map<string, Transaction[]>();
    const userPlanetMap = new Map(users.map(u => [u.id, u.homeworld]));
    return groupBy(transactions, tx => userPlanetMap.get(tx.user));
  }, [users, transactions]);
}
